export default __webpack_public_path__ + "static/media/img-1.10613ee3.png";